import { cx } from "class-variance-authority";

export const HorizontalGroup = ({ label, children }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      <span className="font-bold text-[16px] capitalize">{label}</span>
      <div className="col-span-1 md:col-span-2 flex flex-col">{children}</div>
    </div>
  );
};

export const VerticalGroup = ({ label, children }) => {
  return (
    <div className="flex flex-col gap-3">
      <span className="font-bold text-[16px] capitalize">{label}</span>
      {children}
    </div>
  );
};

export const Checkbox = ({ className, label, ...props }) => {
  return (
    <div className="flex items-center gap-2">
      <input
        {...props}
        type="checkbox"
        className={cx("accent-indigo-500 w-5 h-5", className)}
      />
      {label && <label htmlFor={props.id}>{label}</label>}
    </div>
  );
};

export const CheckboxGroup = ({ label, ...props }) => {
  return (
    <div className="flex flex-col gap-3">
      {label && <span className="font-bold text-sm capitalize">{label}</span>}
      <Checkbox {...props} label={label} />
    </div>
  );
};

export const Input = ({ className, as, ...props }) => {
  const Comp = as || "input";

  return (
    <Comp
      {...props}
      className={cx(
        "rounded-md border border-gray-400 px-4 py-3",
        "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
        "transition duration-300 ease-in-out disabled:bg-gray-100",
        className,
      )}
    />
  );
};

export const InputGroup = ({ label, as, direction = "vertical", ...props }) => {
  return (
    <div
      className={cx(
        "grid",
        direction === "horizontal"
          ? "grid-cols-1 md:grid-cols-3 gap-3"
          : "grid-cols-1 gap-3",
      )}
    >
      {label && (
        <span className="font-bold text-[16px] capitalize mt-3">{label}</span>
      )}
      <div className="col-span-1 md:col-span-2 flex flex-col">
        <Input {...props} as={as} />
      </div>
    </div>
  );
};

export const TextArea = ({ className, ...props }) => {
  return (
    <textarea
      {...props}
      className={cx(
        "rounded-md border border-gray-400 px-4 py-3",
        "focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
        "transition duration-300 ease-in-out disabled:bg-gray-100",
        className,
      )}
    />
  );
};

export const TextAreaGroup = ({ label, direction = "vertical", ...props }) => {
  return (
    <div
      className={cx(
        "grid",
        direction === "horizontal"
          ? "grid-cols-1 md:grid-cols-3 gap-3"
          : "grid-cols-1 gap-3",
      )}
    >
      {label && (
        <span className="font-bold text-[16px] capitalize mt-3">{label}</span>
      )}
      <div className="col-span-1 md:col-span-2 flex flex-col">
        <TextArea {...props} />
      </div>
    </div>
  );
};

export { InputDate, InputDateGroup } from "./input-date";
